<ion-header>
  <ion-toolbar class="header-toolbar">
    <ion-buttons slot="start">
      <ion-back-button [text]="getBackTextWithTranslation()" [defaultHref]="getDefaultHref()"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ 'QUICK_USER.TITLE' | translate }}</ion-title>
    <img style="margin-right: 10px;"
      alt="Translate"
      data-test="qr-language"
      src="assets/icon/whites/translator.svg" width="25" slot="end"
      (click)="goToLanguage()"
      (keypress)="goToLanguage()"/>
  </ion-toolbar>
</ion-header>

<ion-content class="register-page-content" [scrollY]="true">
  <div class="register-page">

    <!-- Background decoration -->
    <div class="register-page__bg-decoration" aria-hidden="true"></div>

    <!-- Card container -->
    <div class="register-page__card">
      <crud-quick-register-form></crud-quick-register-form>
    </div>

    <lib-platform-detection class="register-page__platform"></lib-platform-detection>

  </div>
</ion-content>
